module.exports = __webpack_public_path__ + "media/images/front/icons/cart-28d6728420bc5d5b791407a5776ebf25.png";